import { createAsyncThunk } from '@reduxjs/toolkit';

import { getTermsValue } from '../../../../packages/JsonQuery';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { updateCoworking } from 'shared/slices/jsonQuery';
import { setCoworkingName } from 'shared/slices/tags';
import { ISelectCoworkingParams } from 'shared/types/geoSuggest';
import { IThunkApi } from 'shared/types/redux';
import { updateSearchMeta } from '../../searchMeta';

/**
 * Выбор коворкинга из гео-саджеста → jsonQuery.coworking_id.
 * Сервер не отдаёт тег коворкинга, поэтому имя для чипа сохраняем локально
 * из выбранного саджеста (как в legacy-фильтрах через tagsData.coworkings).
 */
export const selectCoworking = createAsyncThunk<void, ISelectCoworkingParams, IThunkApi>(
  'geo/geoSuggest/selectCoworking',
  async ({ id, name }, { getState, dispatch }) => {
    const jsonQuery = selectJsonQuery(getState());
    const currentIds: number[] = getTermsValue('coworking_id')(jsonQuery) || [];

    dispatch(setCoworkingName({ id, name }));

    if (!currentIds.includes(id)) {
      dispatch(updateCoworking([...currentIds, id]));
    }

    await dispatch(updateSearchMeta());
  },
);
